module.exports = __webpack_public_path__ + "spine/duck.json?81704233beb45db471861e5a5524ab3d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/duck/duck.json
// module id = 1741
// module chunks = 3